import { Component, h, Host, Element, Fragment } from '@stencil/core';
import { ActionTrackingEvent } from '@union-investment/tracking/src/events';
import store from '../store';

@Component({
  tag: 'ui-realestate-property-view',
  styleUrl: 'ui-realestate-property-view.scss',
  shadow: false,
})
export class UiRealEstatePropertyView {
  @Element() el: HTMLUiRealestatePropertyViewElement;

  mapsButton: HTMLUiButtonElement;

  listButton: HTMLUiButtonElement;

  componentDidLoad() {
    /**
     * Change border radius for ui-button from outside shadowRoot for the Map/List button.
     */
    this.mapsButton.shadowRoot.querySelector('button').style.borderRadius =
      '30px 0 0 30px';
    this.listButton.shadowRoot.querySelector('button').style.borderRadius =
      '0 30px 30px 0';
  }

  /**
   * Set active view for property listings between (Gmaps View / Property List)
   */
  setActiveView(view: 'gmaps' | 'list') {
    store.state.activeView = view;
  }

  onClickButtonHandler(label: string) {
    const trackingEvent: ActionTrackingEvent = {
      eventInfo: {
        eventName: `Click on button: ${label}`,
        eventType: 'Action',
      },
      attributes: {
        elementType: 'Button',
        elementLabel: label,
        virtualTarget: 'app_Immobiliensuche',
      },
      category: {
        area: 'Content',
      },
    };
    window.ui?.services?.tracking?.track(trackingEvent);
  }

  noResultsFound() {
    return (
      <div class="no-results-message">
        <ui-headline level={4}>{store.state.noResultMessageTitle}</ui-headline>
        <ui-paragraph
          innerHTML={store.state.noResultMessageHtml}
        ></ui-paragraph>
      </div>
    );
  }

  render() {
    return (
      <Host>
        {store.state.searchResults.hits.length === 0 ? (
          this.noResultsFound()
        ) : (
          <div
            class={`property-view-wrapper ${store.state.activeView} ${store.state.isMobile ? 'mobile' : ''}`}
          >
            <div class="view-switch">
              <ui-button
                variant={
                  store.state.activeView === 'gmaps' ? 'primary' : 'secondary'
                }
                icon="position"
                onClick={() => {
                  this.setActiveView('gmaps');
                  this.onClickButtonHandler(store.state.i18n.map || 'Karte');
                }}
                ref={(el) => {
                  this.mapsButton = el;
                }}
              >
                {store.state.i18n.map || 'Karte'}
              </ui-button>
              <ui-button
                variant={
                  store.state.activeView === 'list' ? 'primary' : 'secondary'
                }
                icon="list"
                onClick={() => {
                  this.setActiveView('list');
                  this.onClickButtonHandler(store.state.i18n.list || 'Liste');
                }}
                ref={(el) => {
                  this.listButton = el;
                }}
              >
                {store.state.i18n.list || 'Liste'}
              </ui-button>
            </div>
            <Fragment>
              {store.state.activeView === 'gmaps' ? (
                <ui-usercentrics-overlay pid="S1pcEj_jZX">
                  <ui-realestate-map-view></ui-realestate-map-view>
                </ui-usercentrics-overlay>
              ) : (
                <ui-realestate-list-view></ui-realestate-list-view>
              )}
            </Fragment>
          </div>
        )}
      </Host>
    );
  }
}
